// Feature
// |
// |
// |__ Name
//    |
//    |__ type.ts              **1**
//    |__ api.ts               **2**
//    |__ index.ts             **3**
//    |__ Or SubFeature.ts     **4**

//           NOTE
//                all files follow this rule: if content of a feature is too much, you can have multiple files
//                like this:
//                  filetypeSubFeature1.ts
//                  filetypeSubFeatureF2.ts
//                  or
//                  apiDeal.ts
//                  apiDealKanban.ts

//           **1**
//                contains all types which is in feature context. types of a feature breaks into:
//                  1. TNameModel            --> the model of the feature in back-end
//                  2. TName                 --> a model which only exist in front-end
//                  3. TNameNormed           --> a model which only exist in front-end
//                  4. TFeatureActionReq     --> api payload type
//                  5. TFeatureActionRes     --> api response type which needs to be normed
//                  6. TFeatureActionOptions --> action function options

//           **2**
//                an stateless class which contains all apis. extended by Base.ts and only returns Data
//                and all functions should start with <api> key word because the feature class will
//                extend this class, then names will never colide

//           **3**
//           **4**
//                the main statefull classes which the exported data is reactive so be carefull. do
//                not mutate the state directly. the class extends api class of itself so every apis
//                stays within the composable itself.

// Function's name:
//    api:
//         apiFunctionName() - api call with no side effects
//
//    feature:
//         fetchFunctionName() - method which calls an api and fills the state
//         getFunctionName() - method which gets data from class instance to outside

export enum EGlobalFormType {
  DEAL = 'deal',
  PEOPLE = 'people',
  COMPANIES = 'companies',
}
export enum EGlobalFormTypeFa {
  DEAL = 'فرصت فروش',
  PEOPLE = 'حقیقی',
  COMPANIES = 'حقوقی',
}

export enum EGlobalServiceType {
  CI = 'ci',
}

export enum EGlobalFetchingServices {
  crm = 'crm',
  product = 'product',
  ipbx = 'ipbx',
  webchat = 'webchat',
  webchat2 = 'webchat2',
  whatsapp = 'whatsapp',
  socket = 'socket',
  sip = 'sip',
  cdr = 'cdr',
  wallboard = 'wallboard',
  money = 'money',
  ci = 'ci',
  cibiz = 'cibiz',
  qaqc = 'qaqc',
  fax = 'fax',
  conference = 'conference',
  conferencelink = 'conferencelink',
  msg = 'msg',
  cellar = 'cellar',
  uaa = 'uaa',
  ticketing = 'ticketing',
  ticket = 'ticket',
  push = 'push',
  status = 'status',
  inventory = 'inventory',
  lead = 'lead',
  invoice = 'invoice',
  sms = 'sms',
  task = 'task',
  deal = 'deal',
  uuid = 'uuid',
  mothership = 'mothership',
  webchatcdn = 'webchatcdn',
  domain = 'domain',
  automation = 'automation',
}

// Store enums
export enum EGlobalStoreEnums {
  RAP_USER_ROLES = 'userRoles',
}
